"use strict";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { LinkButton } from "@/DesignSystem";
import { CallCenterUserCredentialsState } from "./CallCenterSettings.types";

import styles from "./CallCenterSettings.module.scss";

interface ViewCallCenterCredentialsProps {
    credentials: CallCenterUserCredentialsState
    onModifyClicked: () => void
}

function ViewCallCenterCredentials(props: Readonly<ViewCallCenterCredentialsProps>): JSX.Element {
    const { getText } = useTranslation();
    const modifyLabel = cacheStore.GetString("ModifyLabel");

    let userName = props.credentials?.ExternalUsername ?? null;

    let userNameDisplay = (
        <div className={styles.currentEmail} title={userName}>
            {userName}
        </div>
    );

    if (!userName) {
        userNameDisplay = (
            <div className={styles.notConfigured}>
                {getText("CallCenter_Settings_NotConfigured")}
            </div>
        );
    }

    return (
        <div className={styles.viewCredentials}>
            {userNameDisplay}
            <span className={styles.modify}>
                <LinkButton underline={false} onClick={props.onModifyClicked} label={modifyLabel} dataCy="CallCenterModifyCredentials" />
            </span>
        </div>
    );
}

export { ViewCallCenterCredentials };
